import { classNames } from 'libs/react';
import { useMeasure } from 'libs/react';
import { useRef } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import './TableFilterGroup.scss';
/**
 * @component TableFilterGroup
 * @since 1.0.0
 * @hidden
 */
export function TableFilterGroup(props) {
    var _a;
    const { style, title, infos } = Object.assign({ style: 'normal' }, props);
    const head = useRef(null);
    const body = useRef(null);
    const [b, sw, sh] = useMeasure(body);
    const [expanded, setExpanded] = useState((_a = props.expanded) !== null && _a !== void 0 ? _a : false);
    /**
     * @function onToggle
     * @since 1.0.0
     */
    function onToggle() {
        setExpanded(!expanded);
    }
    const className = classNames('table-filter-group', 'table-filter-group--' + style, { 'table-filter-group--has-title': title }, { 'table-filter-group--has-infos': infos }, { 'table-filter-group--is-expanded': expanded });
    return (React.createElement("div", { className: className },
        React.createElement("div", { ref: head, className: "table-filter-group-head", onClick: onToggle },
            React.createElement("div", { className: "table-filter-group-head-side" },
                React.createElement(Icon, { className: "table-filter-group-arrow", value: "chevron-right" })),
            React.createElement("div", { className: "table-filter-group-head-main" }, title && React.createElement(Text, { className: "table-filter-group-title", value: title }))),
        React.createElement("div", { ref: body, className: "table-filter-group-body" },
            React.createElement("div", { className: "table-filter-group-main" }, props.children))));
}
